import { useEffect, useState } from 'react';

import type { SaveStatus } from '../components/SaveIndicator';

type OptimisticChecked = {
  checked: boolean;
  setPendingChecked: (value: boolean) => void;
};

// Keeps a controlled toggle responsive while its save is in flight: the clicked value is shown
// immediately, then reconciled with the server. The pending value is cleared once the server value
// catches up to it, and reverted when the save fails — so a failed refresh never leaves the toggle
// stuck showing an unsaved state.
export function useOptimisticChecked(serverChecked: boolean, status: SaveStatus): OptimisticChecked {
  const [pending, setPending] = useState<boolean | null>(null);

  useEffect(() => {
    if (pending !== null && serverChecked === pending) {
      setPending(null);
    }
  }, [serverChecked, pending]);

  useEffect(() => {
    if (status === 'error') {
      setPending(null);
    }
  }, [status]);

  return {
    checked: pending ?? serverChecked,
    setPendingChecked: setPending,
  };
}
